export const APIConstants = {
    Login: "/user/login",
    ValidateToken: "/user/validate-token",
    Logout: "/user/logout",
    UserById: "/user/userById",
    ForgotPassword: "/user/forget-password",
    WebRTCCreate: "/webrtc/create",
    WebRTCCreatePublic: "/webrtc/create-public",
    WebRTCJoin: "/webrtc/join",
    WebRTCGet: "/webrtc",
    WebRTCGetByUser: "/webrtc/user/meetings",
    WebRTCUpdateStatus: "/webrtc"
}

export class Veriable {
    imgdata: any;
}
